import script from "./NovoGrupo.vue?vue&type=script&lang=ts&setup=true"
export * from "./NovoGrupo.vue?vue&type=script&lang=ts&setup=true"

import "./NovoGrupo.vue?vue&type=style&index=0&id=1eaa9c62&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eaa9c62"]])

export default __exports__